import * as angular from "angular";
import tabbedModal from "./tabbed-modal";
import tabbedModalTab from "./tabbed-modal-tab";

export default angular
	.module("vesl.components.tabbed-modal", [
		tabbedModal,
		tabbedModalTab
	])
	.name;
